// extracted by mini-css-extract-plugin
export var settingsList = "_2t-0";
export var settingsRow = "_2t-1";
export var warningDot = "_2t-2";